import { Component, OnInit, ViewChild } from '@angular/core'
import {
  ChannelNameTokens,
  ConfirmDialogService,
  DataCheckerService,
  selectAllRentals,
  selectChannelByName,
  untilDestroy,
} from '@tokeet/tv3-platform'
import { TableType } from '@tv3/shared/empty-table/table-type'
import { MatSort } from '@angular/material/sort'
import { asyncScheduler, combineLatest, of } from 'rxjs'
import { FormBuilder } from '@angular/forms'
import { MatTableDataSource } from '@angular/material/table'
import { select, Store } from '@ngrx/store'
import { UserStorage } from '@tv3/services/utils/storage.service'
import { TableService } from '@tv3/services/utils/table.service'
import { createLocaleCompareSort } from '@tokeet-frontend/utility'
import { observeOn } from 'rxjs/operators'
import { FilterGroup } from '@tv3/services/utils/filters.service'
import { InquiryChargeService } from '@tv3/services/inquiry-charge.service'
import {
  DeleteLosDiscount,
  DeleteMultipleLosDiscount,
  LosDiscountDialogService,
  LosDiscountGuard,
  LosDiscountModality,
  LosDiscountView,
  losTokeetChannel,
  selectLosDiscountsLoaded,
} from '@tokeet-frontend/los-discount'
import { LosDiscountFilter } from '@tv3/store/los-discount/los-discount.filter'
import { MatPaginator } from '@angular/material/paginator'
import { SelectableRow } from '@tokeet-frontend/utility'
import { environment } from '@tv3/environments/environment'

@Component({
  selector: 'app-los-discount-table',
  templateUrl: './los-discount-table.component.html',
  styleUrls: ['./los-discount-table.component.scss'],
})
export class LosDiscountTableComponent extends SelectableRow implements OnInit {
  @ViewChild('paginator', { static: true }) paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) sort: MatSort

  displayedColumns = [
    'select',
    'name',
    'amount',
    'rentalsView',
    'channelsView',
    'startView',
    'endView',
    'length',
    'guests',
    'createdView',
    'edit',
  ]

  dataSource = new MatTableDataSource<LosDiscountView>()

  filterGroup = FilterGroup.LosDiscounts
  tableType = TableType.LosDiscounts
  isEmptyTable$ = this.tableService.isEmptyTable(this.dataSource)

  isLoaded$ = this.store.pipe(select(selectLosDiscountsLoaded))

  items: LosDiscountView[] = []
  rentals$ = this.store.pipe(observeOn(asyncScheduler), select(selectAllRentals))
  channels$ = combineLatest([of(losTokeetChannel), this.store.pipe(select(selectChannelByName, { name: 'webready' }))])

  filters = this.losDiscountFilter.group
  searchTerm: string

  modalities = LosDiscountModality

  hasLOS = environment.features.losModality

  constructor(
    private fb: FormBuilder,
    private store: Store<any>,
    protected tableService: TableService,
    public inquiryChargeService: InquiryChargeService,
    protected storage: UserStorage,
    private losDiscountFilter: LosDiscountFilter,
    private dataCheckerService: DataCheckerService,
    private losDiscountDialog: LosDiscountDialogService,
    private confirmDialog: ConfirmDialogService
  ) {
    super(tableService, storage, TableType.LosDiscounts)
    this.dataCheckerService.check([LosDiscountGuard])
  }

  ngOnInit() {
    this.dataSource.filterPredicate = this.tableService.filterPredicateFactory(this.displayedColumns)
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortData = createLocaleCompareSort()
    this.setDataSource(this.dataSource)

    this.losDiscountFilter.group.changes.pipe(untilDestroy(this)).subscribe((items) => {
      this.items = this.dataSource.data = items
    })

    this.losDiscountFilter.group.currentFilters.pipe(untilDestroy(this)).subscribe(() => {
      this.paginator.firstPage()
    })
  }

  onSearch(term: string) {
    this.paginator.firstPage()
    this.dataSource.filter = (term + '').trim().toLowerCase()
  }

  onAdd() {
    this.losDiscountDialog.open({
      primaryBtnClass: 'btn btn-success text-uppercase',
      cancelBtnClass: 'btn btn-cst-danger text-uppercase',
      hasModality: environment.features.losModality,
      articleId: 'k782tt9e6k',
    })
  }

  onEdit(item: LosDiscountView) {
    this.losDiscountDialog.open({
      item,
      primaryBtnClass: 'btn btn-success text-uppercase',
      cancelBtnClass: 'btn btn-cst-danger text-uppercase',
      hasModality: environment.features.losModality,
      articleId: 'k782tt9e6k',
    })
  }

  onDeleteSelected() {
    const selectedIds = this.selection.selected.map((item) => item.id)
    this.confirmDialog
      .confirm({
        title: 'Delete selected discounts?',
        body: 'Are you sure you want to delete selected discounts?',
      })
      .subscribe(() => {
        this.store.dispatch(DeleteMultipleLosDiscount({ ids: selectedIds }))
      })
  }

  onDelete(item: LosDiscountView) {
    this.confirmDialog
      .confirm({
        title: 'Delete discount?',
        body: 'Are you sure you want to delete this discount?',
      })
      .subscribe(() => {
        this.store.dispatch(DeleteLosDiscount({ id: item.id }))
      })
  }
}
